export class UserToBusinessLine {
    public id: number | null;
    public user_id: number | null;
    public business_line_id: number | null;

    constructor(data: UserToBusinessLineData | void) {
        if (data === undefined) {
            this.id = null;
            this.user_id = null;
            this.business_line_id = null;
        } else {
            this.id = data.id;
            this.user_id = data.user_id;
            this.business_line_id = data.business_line_id;
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.user_id = null;
        this.business_line_id = null;
    }
}

export type UserToBusinessLineData = {
    id: number | null;
    user_id: number | null;
    business_line_id: number | null;
}